import React from "react";
import { gql } from "@apollo/client";
import { Link } from "@jasperlabs/jux-next";
import RouterLink from "next/link";

import { InvestingEntityTypeLabels } from "type-labels";
import { useYouAreInvestingAsQuery } from "./index.generated";

gql`
	query YouAreInvestingAs {
		account {
			activeInvestingEntity {
				id
				name
				entityTypeEnum
			}
		}
	}
`;

const CurrentlyInvestingAs = () => {
	const { data, loading: isLoading } = useYouAreInvestingAsQuery();

	const activeInvestingEntity = data?.account?.activeInvestingEntity;
	if (isLoading || !activeInvestingEntity) {
		return null;
	}

	const investingEntityTitle =
		activeInvestingEntity.name ||
		InvestingEntityTypeLabels[activeInvestingEntity.entityTypeEnum];

	return (
		<div className="flex w-full justify-center">
			<span className="text-body-sm text-color-body text-center">
				You are currently investing as{" "}
				<Link
					href="/investing-entities"
					aria-label="Investing Entity Title"
					as={RouterLink}
				>
					<span className="text-link-primary hover:text-link-primary-hover">
						{investingEntityTitle}
					</span>
				</Link>
			</span>
		</div>
	);
};

export default CurrentlyInvestingAs;
